import { EditorData } from "../types";

export function isEditorEmpty(data: EditorData) {
  return data.html_content === null;
}
